import { Config } from '@config';
import { GAConfig } from '../../models/ga-config';
import { GACountryCode } from '../../models/ga-country-code.enum';
import { RegistrationGaCategory } from '../../models/registration-ga-category.enum';
import { RegistrationGaType } from '../../models/registration-ga-type.enum';
import { RegistrationGaVersion } from '../../models/registration-ga-version.enum';

export const gaConfigFactory = (config: Config): GAConfig => ({
  category: RegistrationGaCategory.MultiPlanRegistrationPages,
  clientBrandCode: config.clientBrandCode,
  clientName: config.clientName,
  countryCode: GACountryCode.GreatBritain,
  debug: false,
  domainId: config.domainId,
  httpErrorMapping: {},
  type: RegistrationGaType.Standard,
  version: RegistrationGaVersion.NewRepo,
});
